import { signOut } from "@/services/authSession";
import {all, fork, put, takeEvery, select} from 'redux-saga/effects';
import _ from "lodash";
import actions from './actions';

export function* loginRequest() {
    yield takeEvery(actions.LOGIN_REQUEST, function* (payload) {
        // console.log('payload', payload.payload)
        const access = _.get(payload.payload, 'tokens.access');
        const refresh = _.get(payload.payload, 'tokens.refresh');
        const accessTokenExpiration = _.get(payload.payload, 'tokens.access_token_expiration');
        const refreshTokenExpiration = _.get(payload.payload, 'tokens.refresh_token_expiration');
        const user = _.get(payload.payload, 'tokens.user');
        const image = _.get(payload.payload, 'tokens.user_image');
        const company = _.get(payload.payload, 'tokens.company');
        const rawUserFacilities = _.get(payload.payload, 'tokens.user_facilities');
        const user_facilities = Array.isArray(rawUserFacilities) ? rawUserFacilities : [];
        const is_companyadmin = _.get(payload.payload, 'tokens.is_companyadmin');
        const is_superuser = _.get(payload.payload, 'tokens.is_superuser');
        const userId = _.get(payload.payload, 'tokens.user_id');
        const rawPermission = _.get(payload.payload, 'tokens.permission');
        const permission =
            rawPermission && typeof rawPermission === "object" && !Array.isArray(rawPermission)
                ? rawPermission
                : {};

        const role = _.get(payload.payload, 'tokens.role');
        const first_name = _.get(payload.payload, 'tokens.first_name');
        const last_name = _.get(payload.payload, 'tokens.last_name');
        const middle_name = _.get(payload.payload, 'tokens.middle_name');
        const email = _.get(payload.payload, 'tokens.email');
        if (access) {
            yield put({
                type: actions.LOGIN_SUCCESS,
                access: access,
                refresh: refresh,
                accessTokenExpiration: accessTokenExpiration,
                refreshTokenExpiration: refreshTokenExpiration,
                user: user,
                userId: userId,
                image: image,
                company: company,
                role: role,
                user_facilities: user_facilities,
                is_companyadmin: is_companyadmin,
                is_superuser: is_superuser,
                permission: permission,
                first_name,
                last_name,
                middle_name,
                email,
            });
        } else {
            yield put({type: actions.LOGIN_ERROR});
        }
    });
}

export function* updateUserInfoRequest() {
    yield takeEvery(actions.USERINFO_UPDATE_REQUEST, function* (payload) {
        // console.log('payload', payload.payload)

        const user = _.get(payload.payload, 'tokens.user');
        const image = _.get(payload.payload, 'tokens.user_image');
        const company = _.get(payload.payload, 'tokens.company');
        const rawUserFacilities = _.get(payload.payload, 'tokens.user_facilities');
        const user_facilities = Array.isArray(rawUserFacilities) ? rawUserFacilities : [];
        const is_companyadmin = _.get(payload.payload, 'tokens.is_companyadmin');
        const is_superuser = _.get(payload.payload, 'tokens.is_superuser');
        const userId = _.get(payload.payload, 'tokens.user_id');
        const rawPermission = _.get(payload.payload, 'tokens.permission');
        const permission =
            rawPermission && typeof rawPermission === "object" && !Array.isArray(rawPermission)
                ? rawPermission
                : {};

        const role = _.get(payload.payload, 'tokens.role');
        const first_name = _.get(payload.payload, 'tokens.first_name');
        const last_name = _.get(payload.payload, 'tokens.last_name');
        const middle_name = _.get(payload.payload, 'tokens.middle_name');
        const email = _.get(payload.payload, 'tokens.email');

        yield put({
            type: actions.USERINFO_UPDATE_SUCCESS,
            user: user,
            userId: userId,
            image: image,
            company: company,
            role: role,
            user_facilities: user_facilities,
            is_companyadmin: is_companyadmin,
            is_superuser: is_superuser,
            permission: permission,
            first_name,
            last_name,
            middle_name,
            email,
        });
    });
}

export function* loginSuccess() {
    yield takeEvery(actions.LOGIN_SUCCESS, function* () {});
}

export function* logout() {
    yield takeEvery(actions.LOGOUT, function* () {
        yield signOut();
    });
}

export function* loginError() {
    yield takeEvery(actions.LOGIN_ERROR, function* () {
    });
}

export function* checkAuthorization() {
    yield takeEvery(actions.CHECK_AUTHORIZATION, function* () {
        const access = yield select(state => state.Auth?.access);
        if (access) {
            return;
        } else {
            yield put({type: actions.LOGIN_ERROR});
        }
    });
}

export default function* LoginSaga() {
    yield all([
        fork(checkAuthorization),
        fork(loginRequest),
        fork(updateUserInfoRequest),
        fork(loginSuccess),
        fork(loginError),
        fork(logout),
    ]);
}
